export const overrideConsole = () => {
  // In production: suppress noisy diagnostic output only.
  // console.warn and console.error are kept intact so runtime
  // errors and warnings remain visible in production monitoring.
  if (process.env.NODE_ENV === "production") {
    const noop = () => {};
    console.log   = noop;
    console.info  = noop;
    console.debug = noop;
    console.table = noop;
  }
  // Development: no overrides — native console behavior is preserved.
};
